import angular from 'angular';
import template from './uri.html';
import controller from './uri.controller';
import UriComponent from './uri.component';

const uriConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('uri', {
		title:      'URI',
		template,
		icon:       'fa fa-globe',
		controller,
		children:   false,
		selectable: true,
		settings:   new UriComponent(),
		views: [
			{
				name:     'Display',
				template: 'kform/components/uri/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/common/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
	});
};

export default angular.module('app').config(uriConfig);
